'use client';

// Mounted once in Providers. Exists only to run initRum in the client bundle at
// app load — it renders nothing. Config is baked at build time as NEXT_PUBLIC_DD_*
// (see rum.ts for why Terraform cannot deliver it).
import { initRum } from '@/observability/rum';

export function RumInit(): null {
  initRum({
    enabled: process.env.NEXT_PUBLIC_DD_RUM_ENABLED === 'true',
    applicationId: process.env.NEXT_PUBLIC_DD_APPLICATION_ID ?? '',
    clientToken: process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN ?? '',
    version: process.env.NEXT_PUBLIC_DD_VERSION ?? '',
    env: process.env.NEXT_PUBLIC_DD_ENV ?? 'sandbox',
  });
  return null;
}
